import { IconDeviceDesktop, IconMoon, IconSun } from '@tabler/icons-react';

export const colorSchemesMap = {
    auto: 'light',
    light: 'dark',
    dark: 'auto',
} as const;

export const colorSchemesIconsMap = {
    auto: IconSun,
    light: IconMoon,
    dark: IconDeviceDesktop,
} as const;
